import AuthApiService from "../core/services/authapi.service";

export default {
  sendForgotPasswordCode(email) {
    return AuthApiService.post(`forgotPassword/SendCode?email=${email}`);
  },
  resetPassword(obj) {
    return AuthApiService.post(`forgotPassword`, obj);
  },
};
